'use client';

import { ExpressiveAnchorButton } from '@exploration/shared-components';
import { tablet } from '@thrivent/midwest-shared';
import styled from 'styled-components';

export const AnchorButton = styled(ExpressiveAnchorButton)`
  flex-shrink: 0;
  height: 3rem;
  margin-top: 1rem;

  ${tablet} {
    margin-top: 0;
    font-size: 1rem;
  }
`;
